import { twMerge } from 'tailwind-merge';

import Badge from '../badge/Badge';

const SoldBadge = ({ className, text = 'sold out' }: { className?: string; text?: string }) => {
  return <Badge className={twMerge('sold-out-badge', className)} text={text} />;
};

export default SoldBadge;
